import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { EscalatingReportSearchParams } from './missed-recall-report.model';
import { EscalatingReportState } from './missed-recall.reducer';

@Injectable()
export class MissedRecallAction {
    static setFromDate = createAction('[Reports:Recall/Missed] Set From Date',
        props<{fromDate: Date}>()
    );

    static getEscalateReport = createAction('[Reports:Recall/Missed] Get Escalate Report',
        props<{searchParameters: EscalatingReportSearchParams}>()
   );
    static getEscalateReportSuccess = createAction('[Reports:Recall/Missed] Get Escalate Report Success',
        props<{reports: EscalatingReportState}>()
    );
    static getEscalateReportFailed = createAction('[Reports:Recall/Missed] Get Escalate Report Failed');
}
